import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { useShowInfluencerCampaignBar } from 'src/features/campaigns/influencers/components/influencer-campaign-bar/hooks/use-show-influencer-campaign-bar';
import { StyledCloseBtn, StyledContainer } from './not-applicable-campaign.styles';
export const NotApplicableCampaign: FC<{
  influencerName?: string;
}> = ({
  influencerName
}) => {
  const [isShowInfluencerCampaignBar, hideInfluencerCampaignBar] = useShowInfluencerCampaignBar();
  if (!isShowInfluencerCampaignBar) return null;
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="NotApplicableCampaign" data-sentry-source-file="not-applicable-campaign.tsx">
      <FontAwesomeIcon icon={faCircleInfo} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="not-applicable-campaign.tsx" />
      <p>You do not qualify for the {influencerName} viewers exclusive offer. More great deals are coming soon!</p>

      <StyledCloseBtn onClick={hideInfluencerCampaignBar} data-sentry-element="StyledCloseBtn" data-sentry-source-file="not-applicable-campaign.tsx">
        <FontAwesomeIcon icon={faXmark} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="not-applicable-campaign.tsx" />
      </StyledCloseBtn>
    </StyledContainer>;
};